import { Component, OnInit, Input } from '@angular/core';


@Component({ standalone: false,
  selector: 'app-custom-image',
  templateUrl: './custom-image.component.html',
  styleUrls: ['./custom-image.component.scss','../../../styles/font-awesome.scss'],
})
export class CustomImageComponent implements OnInit {
  @Input() src: string;
  @Input() alt: string;
  @Input() type: string;
  @Input() name: string = 'default';
  @Input() size: string;
  @Input() data: any;
  @Input() randomNumber: number
  @Input() loading: boolean = false;
  constructor() { }

  ngOnInit(): void {
    if (!this.randomNumber) {
      this.randomNumber = this.getRandomNumber();
    }
  }

  getUniqueColor(name: string): string {
    let hash = 0;

    // Calcula un valor hash basado en el nombre
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    // Genera colores pasteles menos intensos en formato hexadecimal
    const minValue = 150;
    const maxValue = 240;
    const range = maxValue - minValue;
    
    const r = (hash % range) + minValue;
    const g = ((hash >> 8) % range) + minValue;
    const b = ((hash >> 16) % range) + minValue;
  
    const color = `#${r.toString(16)}${g.toString(16)}${b.toString(16)}`;
    return color;
  }

  getRandomNumber(): number {
    return Math.floor(Math.random() * 100);
  }

  get routeInitials(): string {
    const words = (this.name || '').trim().split(/\s+/).filter((w: string) => w.length > 0);
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return (this.name || '').trim().substring(0, 2).toUpperCase();
  }

  get routePlaceholderColor(): string {
    const name = this.name || '';
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const h = Math.abs(hash) % 360;
    return `hsl(${h}, 55%, 45%)`;
  }
}
